import R from 'ramda';
import actionTypes from '../actionTypes';

const initialState = {
  invites: [],
};

export default (state = initialState, action) => {
  let index;

  switch (action.type) {
    case actionTypes.INVITES_GET_REQUEST:
    case actionTypes.INVITES_USER_GET_REQUEST:
      return { ...state, invites: [], status: action.type };

    case actionTypes.INVITE_GET_REQUEST:
    case actionTypes.INVITE_CREATE_REQUEST:
    case actionTypes.INVITE_UPDATE_REQUEST:
    case actionTypes.INVITE_GET_BY_KEY_REQUEST:
    case actionTypes.RESEND_DEAL_INVITATION_REQUEST:
    case actionTypes.RESEND_DEAL_INVITATION_SUCCESS:
      return { ...state, status: action.type };

    case actionTypes.INVITES_GET_ERROR:
    case actionTypes.INVITES_USER_GET_ERROR:
    case actionTypes.RESEND_DEAL_INVITATION_ERROR:
      return { ...initialState };

    case actionTypes.INVITES_GET_SUCCESS:
    case actionTypes.INVITES_USER_GET_SUCCESS:
      return { ...state, status: action.type, invites: action.invites };

    case actionTypes.INVITE_GET_ERROR:
    case actionTypes.INVITE_CREATE_ERROR:
    case actionTypes.INVITE_GET_BY_KEY_ERROR:
      return {
        ...state,
        status: action.type,
        error: action.error,
        selectedInvite: null,
      };

    case actionTypes.INVITE_GET_SUCCESS:
    case actionTypes.INVITE_GET_BY_KEY_SUCCESS:
    case actionTypes.INVITE_SELECT:
      return { ...state, status: action.type, selectedInvite: action.invite };

    case actionTypes.INVITE_CREATE_SUCCESS:
      return {
        ...state,
        status: action.type,
        selectedInvite: action.invite,
        invites: [...state.invites, ...action.invite],
      };

    case actionTypes.INVITE_UPDATE_SUCCESS:
      index = R.findIndex(R.propEq('id', action.invite.id))(state.invites);
      if (index === -1) {
        return {
          ...state,
          status: action.type,
          selectedInvite: action.invite,
          invites: state.invites.concat(action.invite),
        };
      } else {
        state.invites[index] = action.invite;
        return {
          ...state,
          status: action.type,
          selectedInvite: action.invite,
          invites: state.invites,
        };
      }

    case actionTypes.INVITE_DELETE_SUCCESS:
      index = R.findIndex(R.propEq('id', parseInt(action.inviteId, 10)))(
        state.invites
      );

      if (index !== -1) {
        return {
          ...state,
          status: action.type,
          selectedInvite: null,
          invites: R.remove(index, 1, state.invites),
        };
      } else {
        return { ...state, status: action.type, selectedInvite: null };
      }

    case actionTypes.DEAL_UPDATE_SUCCESS:
      index = R.findIndex(R.propEq('deal', action.deal.id))(state.invites);
      if (index !== -1) {
        state.invites[index].deal_info = {
          ...state.invites[index].deal_info,
          ...action.deal,
        };
        return {
          ...state,
          status: action.type,
          selectedInvite: action.invite,
          invites: [...state.invites],
        };
      } else {
        return state;
      }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/redux/reducers/invites.js